import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import EditIcon from '@mui/icons-material/Edit';
import { Button } from '@mui/material';
import { format_date } from '../../../Utils/Dateutils';
import { deleteJobworkPay } from '../../../Store/PHPSlice/Jobwork/jobworkApi';

const TableBody = ({
    serialNumber,
    id,
    dt,
    fdt,
    tdt,
    jobMemo,
    empId,
    empNm,
    totamt,
    totqty,
    tds,
    tdsamt,
    gst,
    gstamt,
    netamt,
    deamt,
    clothamt,
    payableamt,
    sts,
    pay_sts,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();

    const handleDeleteClick = () => {
        // Show confirmation dialog

        const isConfirmed = window.confirm("you want to delete this Jobwork Payment?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteJobworkPay(id))
                .then(() => {
                    // Reload the page to show updated results
                    // toast.success("Cloth Issue Deleted Sucessfully");
                    alert("Jobwork Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }


    };

    const handleViewClick = () => {
        window.open(`/jobwork-payment-view/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handlePendingClick = () => {
        window.open(`/payment-entry/${id}`, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
    };


    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        // window.open(`/ClothIssueEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {format_date(dt)}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {`${format_date(fdt)} to ${format_date(tdt)}`}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {jobMemo}
                </TableCell>



                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {empNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {totqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {totamt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {tds}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {tdsamt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {gst}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {gstamt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {netamt}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {deamt}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {clothamt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {payableamt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    {pay_sts === '1' ? <span style={{ color: 'green', fontWeight: 'bold' }}>Paid</span> : <Button variant="contained" color="warning" size='small' onClick={handlePendingClick}>Pending</Button>}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap', fontSize: '0.9rem' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${pay_sts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
